/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".flag[_ngcontent-%COMP%]{width:16px}img.mat-card-image[_ngcontent-%COMP%]{max-height:300px}.carousel-images[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-height:120px;border-radius:10px}"];
export { styles as styles };
